import React, { Component } from 'react';
import { Badge, Icon } from "antd-min";
import './index.less';

interface IChatBadgeProps {
    count: number;
    handleClick: (data) => void;
    label: string;
}

export const ChatBadge: React.FC<IChatBadgeProps>  = ({
    count,
    handleClick,
    label
}: IChatBadgeProps) => {
    return (
        <div onClick={handleClick} className="chat-badge-container">
            <Badge 
                count={count}
                className={label}
            >
                <span className={label}>
                    <svg className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1278" width="16" height="16"><defs><style type="text/css"></style></defs><path d="M768 384C732.672 384 704 412.672 704 448 704 483.328 732.672 512 768 512 803.328 512 832 483.328 832 448 832 412.672 803.328 384 768 384L768 384ZM512 832C474.624 832 438.528 827.648 403.84 820.256L253.184 910.816 255.2 762.368C139.712 692.928 64 578.112 64 448 64 235.936 264.576 64 512 64 759.424 64 960 235.936 960 448 960 660.096 759.424 832 512 832L512 832ZM512 0C229.248 0 0 200.608 0 448 0 589.408 75.04 715.328 192 797.408L192 1024 416.288 887.904C447.328 893.024 479.264 896 512 896 794.752 896 1024 695.424 1024 448 1024 200.608 794.752 0 512 0L512 0ZM256 384C220.672 384 192 412.672 192 448 192 483.328 220.672 512 256 512 291.328 512 320 483.328 320 448 320 412.672 291.328 384 256 384L256 384ZM512 384C476.672 384 448 412.672 448 448 448 483.328 476.672 512 512 512 547.328 512 576 483.328 576 448 576 412.672 547.328 384 512 384L512 384Z" p-id="1279"></path></svg>
                </span>
            </Badge>
        </div>
    );
}